import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_PersonAuditLog_ActionsMenu_ApiEnum {
    'archive' = 'archive',
}

export enum Config_PersonAuditLog_Modules_ApiEnum {
    'results' = 'results',
    'overview' = 'overview',
    'indications' = 'indications',
}

export enum Config_PersonAuditLog_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_PersonAuditLog_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_PersonAuditLog_ApiInterface
    extends ConfigDataInterface<
        Config_PersonAuditLog_Modules_ApiEnum,
        Config_PersonAuditLog_ActionsMenu_ApiEnum,
        Config_PersonAuditLog_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_PersonAuditLog_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
